
<div class="grid-container">
    <div class="catFilterButtons">
        <p>Filter by category:</p>
        <mat-button-toggle-group name="catFilterButtons" #category aria-label="Category filter buttons" [formControl]="categoryFilter">
            <mat-button-toggle>All</mat-button-toggle>
            <mat-button-toggle *ngFor="let category of categories" class="cat-default" [class]="cssClass(category.name)" [value]="category.name">{{ category.name }} </mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <span class="spacer"></span>
    <div class="action-buttons">
        <button mat-raised-button color="primary" (click)="addCalendarEvent()" aria-label="Add New Calendar Event">
            <mat-icon>add</mat-icon>
            <span>Add Event</span>
        </button>
    </div>
</div>

<mat-card class="mat-elevation-z3">
    <div class="search-container" color="primary">
        <app-search-bar #search (searchEvent)="applySearchFilter($event);" (clearSearchEvent)="clearFilter();"></app-search-bar>
    </div>

    <div class="table-wrapper">
        <table #table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
            <!-- eventName Column -->
            <ng-container matColumnDef="eventName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Name</th>
                <td mat-cell *matCellDef="let event">{{ event.eventName }}</td>
            </ng-container>

            <!-- eventDesc Column -->
            <ng-container matColumnDef="eventDesc">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Desc</th>
                <td mat-cell *matCellDef="let event">{{ event.eventDesc }}</td>
            </ng-container>

            <!-- categoryEvent Column -->
            <ng-container matColumnDef="categoryEvent">
                <th mat-header-cell *matHeaderCellDef>Categories</th>
                <td mat-cell *matCellDef="let event">
                    <app-category-tags
                        [itemCategories]="event.eventCategories"
                        [items]="calendarEvents"
                        [itemName]="event.eventName"
                        [itemId]="event.eventId"
                        [categories]="categoryTags"
                        [categoryNames]="categoryNames"
                        categoryType="calendarEvents"
                        key="eventName"
                        localStorageKey="events"
                    >
                    </app-category-tags>
                </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef style="width: 200px"></th>
                <td mat-cell *matCellDef="let event">
                    <button mat-flat-button color="accent" (click)="expandedEvent = expandedEvent === event ? null : event">
                        Event Dates
                    </button>
                    <button mat-flat-button color="primary" (click)="editCalendarEvent(event)">Edit</button>
                    <button mat-flat-button color="warn" (click)="deleteCalendarEvent(event)">Delete</button>
                </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let event" [attr.colspan]="columnsToDisplay.length">
                    <div class="eventDates-container" [@detailExpand]="event == expandedEvent ? 'expanded' : 'collapsed'">
                        <ng-container *ngIf="expandedEvent === event">
                            <app-event-details [eventId]="event.eventId"></app-event-details>
                        </ng-container>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
                mat-row
                *matRowDef="let event; let index = dataIndex; columns: displayedColumns;" 
                [class.evenRow]="index % 2 == 0"
                class="event-row"
                [class.event-row-expanded]="expandedEvent === event"
            ></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: ['expandedDetail']"
                class="eventsDates-row"
                [class.event-row-expanded]="expandedEvent === row"
            ></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                    No events matching the filter
                    <span *ngIf="!(categoryFilter.value && !search.value)">"{{ search.value }}"</span>
                    <span *ngIf="categoryFilter.value"> in category {{ categoryFilter.value }}</span>
                </td>
            </tr>
        </table>
    </div>
    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
</mat-card>
